import * as L from 'leaflet';
import {
  ParamsCreatePolygon,
  ResponseCreatePolygon,
} from '../models/manager-leaflet.model';
import { adaptCoordsToPolyline } from '../adapters/adapt-Coords-Polyline.adapter';
import { adaptCoordsToPolygon } from '../adapters/adapt-coords-polygon.adapter';

const DEFAULT_OPTIONS: L.PolylineOptions = {
  color: 'blue',
  opacity: 1,
  weight: 3,
  interactive: false,
  fill: true,
};

export function createPolygon(
  params: ParamsCreatePolygon
): ResponseCreatePolygon {
  try {
    const { coordinates } = params;

    // VALIDACIONES
    if (!coordinates || coordinates.length === 0) {
      return {
        polygon: L.polygon([]),
        error: 'No se detecto correctamente la geocerca',
      };
    }
    const validCoords = coordinates.every(
      (coord) =>
        typeof coord.latitude === 'number' &&
        typeof coord.longitude === 'number' &&
        !isNaN(coord.latitude) &&
        !isNaN(coord.longitude)
    );
    if (!validCoords) {
      return {
        polygon: L.polygon([]),
        error: 'Las coordenadas deben ser números válidos',
      };
    }

    const options: L.PolylineOptions = {
      ...DEFAULT_OPTIONS,
      ...(params.options ?? {}),
      // interactive: false,
    };

    // CREAR EL POLYGON
    const adaptCoordinates = adaptCoordsToPolygon(coordinates);
    const polygon = L.polygon(adaptCoordinates, options);
    if (!polygon) {
      return {
        polygon: L.polygon([]),
        error: 'No se pudo crear el polygon',
      };
    }
    return { polygon, error: null };
  } catch (error) {
    return {
      polygon: L.polygon([]),
      error: 'Error desconocido al crear polygon',
    };
  }
}
